import Inbox from './Inbox'
import Compose from './Compose'
import MessageQueue from './MessageQueue'
export default { Inbox, Compose, MessageQueue }
